
export default "/assets/eye-slash-micro.3c231ae8.svg"